function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 26.688c5.875 0 10.688-4.813 10.688-10.688S21.875 5.312 16 5.312 5.312 10.125 5.312 16 10.125 26.688 16 26.688zm0-24c7.375 0 13.313 5.938 13.313 13.313S23.375 29.314 16 29.314 2.687 23.376 2.687 16.001 8.625 2.688 16 2.688zM13.313 22V10l8 6z"
});

var SvgSharedVideo = function SvgSharedVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32"
  }), _ref);
};

export default SvgSharedVideo;